export class ForbiddenError extends Error {
    constructor() {
        super('not_allowed');
        this.name = 'ForbiddenError';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ConnectionError extends Error {
    constructor() {
        super('Connection error. Check your network permissions.');
        this.name = 'ConnectionError';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
